import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { BottomNav } from "../components/BottomNav";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Hammer, BarChart3, Sliders, Home, CheckSquare, User, LogOut } from "lucide-react";

const OWNER_TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, to: "/owner", end: true },
  { id: "jobs", label: "Jobs", icon: Hammer, to: "/owner/jobs" },
  { id: "reports", label: "Reports", icon: BarChart3, to: "/owner/reports" },
  { id: "settings", label: "Settings", icon: Sliders, to: "/owner/settings" },
];

const MANAGER_TABS = [
  { id: "home", label: "Home", icon: Home, to: "/manager", end: true },
  { id: "my_jobs", label: "My Jobs", icon: CheckSquare, to: "/manager/jobs" },
  { id: "reports", label: "Reports", icon: BarChart3, to: "/manager/reports" },
  { id: "profile", label: "Profile", icon: User, to: "/manager/profile" },
];

function Sidebar({ tabs, role }) {
  const { user, logout } = useAuth();
  return (
    <aside className="hidden lg:flex flex-col fixed inset-y-0 left-0 w-64 bg-white border-r border-slate-200 z-40">
      <div className="flex items-center gap-3 px-6 py-5 border-b border-slate-100">
        <div className="h-10 w-10 rounded-xl copper-gradient flex items-center justify-center text-white font-display font-black text-xl">C</div>
        <div>
          <h1 className="font-display text-lg font-black leading-none text-slate-900">Copper Craft</h1>
          <p className="text-xs text-slate-400 mt-0.5">{role === "OWNER" ? "Owner Portal" : "Manager Portal"}</p>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.id}
              to={t.to}
              end={t.end}
              data-testid={`sidenav-${t.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl font-bold text-sm transition-colors ${
                  isActive ? "bg-[#F9EFEA] text-[#9A462B]" : "text-slate-500 hover:bg-slate-50"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
                  {t.label}
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="px-3 py-4 border-t border-slate-100">
        <div className="px-4 mb-2">
          <p className="text-sm font-bold text-slate-800 truncate">{user?.name}</p>
          <p className="text-xs text-slate-400 truncate">{user?.email}</p>
        </div>
        <button
          data-testid="sidebar-logout-button"
          onClick={logout}
          className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl font-bold text-sm text-red-600 hover:bg-red-50 transition-colors"
        >
          <LogOut className="h-5 w-5" /> Log Out
        </button>
      </div>
    </aside>
  );
}

export function AppLayout({ role }) {
  const tabs = role === "OWNER" ? OWNER_TABS : MANAGER_TABS;
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Sidebar tabs={tabs} role={role} />
      <main className="lg:pl-64 min-h-screen">
        <div className="max-w-screen-2xl mx-auto pb-28 lg:pb-10">
          <Outlet />
        </div>
      </main>
      <BottomNav tabs={tabs} />
    </div>
  );
}
